// src/main.ts
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import pinia from "@/stores";
import './utils/resize-observer';
import { ElMessage } from 'element-plus'

const app = createApp(App)

// 注册 Element Plus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

// 监听 同步脚本错误 + ResizeObserver错误 + ChunkLoadError
window.addEventListener('error', (event) => {
    const errorMsg = event.message || '';
    if (errorMsg.includes('ResizeObserver loop completed') || errorMsg.includes('ResizeObserver')) {
        event.preventDefault();
        process.env.NODE_ENV === 'development' && console.debug('忽略 ResizeObserver 报错');
        return;
    }
    if (errorMsg.includes('Loading chunk') && errorMsg.includes('failed')) {
        event.preventDefault();
        ElMessage.error('页面资源加载失败，服务可能已断开！');
        return;
    }
    console.error('全局脚本错误:', event.error);
});

// 监听 所有未捕获的Promise异常
window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason;
    const errorMsg = error?.message || '';
    if (errorMsg.includes('ResizeObserver loop completed') || errorMsg.includes('ResizeObserver')) {
        event.preventDefault();
        process.env.NODE_ENV === 'development' && console.debug('忽略 ResizeObserver Promise 报错');
        return;
    }
    if (error?.name === 'ChunkLoadError' || /Loading chunk.*failed/.test(errorMsg)) {
        event.preventDefault(); // 彻底阻止红屏报错层
        ElMessage.error({
            message: '服务已停止运行，暂时无法加载新页面 😊',
            duration: 8000,
            showClose: true
        });
        return;
    }
    console.error('全局未捕获Promise错误:', error);
});

// 注册插件
app.use(router)
app.use(pinia);

// 初始化Pinia用户状态
import { useUserStore } from '@/stores/user'
const userStore = useUserStore()
userStore.initState()

// 注册ElementPlus
app.use(ElementPlus, {
    locale: zhCn,
    image: { lazy: true }
})

app.mount('#app')